import { Amplify } from "aws-amplify";

/**
 * Configure Amplify Auth against the Operations Console staff pool — a
 * separate pool from customers and contractors (design doc §3). USER_SRP
 * InitiateAuth flow, same as the other apps. Values are injected at build
 * time from the CDK Ops Identity stack outputs.
 */
function required(name: keyof ImportMetaEnv): string {
  const value = import.meta.env[name];
  if (!value) {
    throw new Error(
      `Missing required Vite env var ${String(name)}. ` +
        "It must be injected at build time from the CDK Ops Identity stack outputs.",
    );
  }
  return value;
}

export function configureAuth(): void {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: required("VITE_USER_POOL_ID"),
        userPoolClientId: required("VITE_USER_POOL_CLIENT_ID"),
        loginWith: { email: true },
      },
    },
  });
}
